import React from 'react';

import AddonsPayment from '../components/AddonsPayment';
import AddonsPaymentV2 from '../components/AddonsPaymentV2';
import RequestProvider from '../../../../RequestProvider';
import { getStockAssetRecords } from '../../../../../common/api';


export default function AddonsPaymentContainer(props) {
  const { isNewDesign } = props;
  return (
    <RequestProvider
      requests={{
        getStockAssetRecords: getStockAssetRecords()
      }}>

      {(requests) =>
      isNewDesign ?
      <AddonsPaymentV2 {...requests} {...props} /> :

      <AddonsPayment {...requests} {...props} />}


    </RequestProvider>);

}